import { InputFieldState } from '@servicetitan/form-state';

export const enableAutoValidationOnValidationError = (field: InputFieldState<any>) => async () => {
    const { hasError } = await field.validate();

    if (hasError) {
        field.enableAutoValidation();
    }
};
